import React from "react";
import {TopRightNav} from "../cmp/header/TopRightNav";
import {useUnitsState} from "../store/UnitsState";

export function PageMap() {

  const state = useUnitsState()

  return <div id="app-storefront-index">
    <header>
      <h1>{state.company.name}</h1>
      <div data-component="TopRightNav"><TopRightNav/></div>
    </header>
  </div>
}